import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=633d118a&scoped=true&"
import script from "./FormHeader.vue?vue&type=script&lang=js&"
export * from "./FormHeader.vue?vue&type=script&lang=js&"
import style0 from "./FormHeader.vue?vue&type=style&index=0&id=633d118a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633d118a",
  null
  
)

export default component.exports